export default __webpack_public_path__ + "static/media/title.744a5f52.jpg";